import React, { useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useMessageModal } from '../../contexts/MessageModalContext';
import content from '../../i18n/content';
import dvirMemoji from '../../assets/dvir-memoji.png';
import './Hero.css';
import LogoMarquee from '../LogoMarquee/LogoMarquee';

export default function Hero() {
  const { lang } = useLanguage();
  const t = content[lang].hero;
  const { openModal } = useMessageModal();
  const avatarRef = useRef(null);

  useEffect(() => {
    const MAX_TX = 35;
    const MAX_TY = 20;
    const LERP = 0.07;

    let targetX = 0, targetY = 0;
    let curX = 0, curY = 0;
    let rafId;

    function tick() {
      curX += (targetX - curX) * LERP;
      curY += (targetY - curY) * LERP;
      const img = avatarRef.current;
      if (img) {
        img.style.transform = `translate(${curX}px, ${curY}px)`;
      }
      rafId = requestAnimationFrame(tick);
    }

    function onMouseMove(e) {
      targetX = ((e.clientX / window.innerWidth) * 2 - 1) * MAX_TX;
      targetY = ((e.clientY / window.innerHeight) * 2 - 1) * MAX_TY;
    }

    function onMouseLeave() {
      targetY = 0;
      targetX = 0;
    }

    rafId = requestAnimationFrame(tick);
    window.addEventListener('mousemove', onMouseMove);
    document.documentElement.addEventListener('mouseleave', onMouseLeave);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('mousemove', onMouseMove);
      document.documentElement.removeEventListener('mouseleave', onMouseLeave);
    };
  }, []);

  return (
    <section id="topLine" className="hero">
      <div className="hero-center">
        <div className="hero-content-row">
          <h1 className="hero-pixel-title">HI, I'M DVIR</h1>
          <p className="hero-subtitle">
            {t.subtitleLines.map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < t.subtitleLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
          <div className="hero-avatar-wrap">
            <img ref={avatarRef} src={dvirMemoji} alt={t.name} className="hero-avatar-img" />
          </div>
          <button
            type="button"
            className="hero-cta-contact"
            style={{ sx: { lg: { paddingTop: '5.0rem' } ,md: { paddingTop: '1rem' } ,sm: { paddingTop: '0rem' } }}}
            onClick={openModal}
          >
            {t.ctaPrimary}
          </button>
        </div>
        <LogoMarquee />
      </div>
      <span aria-hidden="true" />
    </section>
  );
}
